import { Checkbox, Form, Input, InputNumber, Radio, Select, Spin } from "antd";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { useWatch } from "antd/es/form/Form";

function ProduceMarket({ periodId }) {
  const url = "sch/get_crop_market_produce";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save);
  const { mrktHow } = useSelector((state) => state.fetch);
  const { data, activeObjSchemes } = useSelector((state) => ({
    data: state.obj.activeObj["cropProduce"],
    activeObjSchemes: state.obj.activeObj["schemes"],
    data: state.fetch.data[url] || [],
  }));

  const handleCancel = async () => {
    await navigate("/scheme/public-scheme-view");
    await form.resetFields();
  };

  async function fetchCropProduceData() {
    await dispatch(
      fetchData({
        url: url,
        cmpSchId: activeObjSchemes?.schId,
        cmpProId: periodId,
        limit: null,
        start: 0,
      })
    );
  }

  const plainOptions = ["Yes", "No"];

  const onFinish = async (data) => {
    data.cmpId = data?.cmpId ? data?.cmpId : null;
    data.cmpSchId = activeObjSchemes?.schId;
    data.cmpProId = periodId;
    const res = await dispatch(
      save({
        ...data,
        url: "sch/crop_market_produce",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const initialFormValues = {
    ...data,
  };

  const cmpMarket = useWatch("cmpAvailMarket", form);

  useEffect(() => {
    fetchCropProduceData();
  }, [periodId]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
      });
    }
  }, [data]);

  return (
    <div>
      <div className="graph_h1 !text-[#1A1A1A]  mt-[2.5rem]">
        Crops & Produce and Market
      </div>

      <Form
        layout="vertical"
        ref={formRef}
        name="control-ref"
        onFinish={onFinish}
        className="mt-[1.25rem]"
        style={{
          maxWidth: "100%",
        }}
        form={form}
        initialValues={initialFormValues}
      >
        <Form.Item
          name="cmpAvailMarket"
          label="Market is readily Available"
          rules={[
            {
              required: false,
              message: "Required field",
            },
          ]}
        >
          <Radio.Group options={plainOptions} />
        </Form.Item>
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
          {cmpMarket === "Yes" && (
            <>
              {" "}
              <Form.Item
                name="cmpMarket"
                label="Where do you market your produce?"
                rules={[
                  {
                    required: false,
                    message: "Please add where do you market your produce?",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="cmpHowMarket"
                className=""
                label={"How do you market your produce"}
                rules={[
                  {
                    required: true,
                    message: "Please select how do you market your produce",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    mrktHow?.length > 0 &&
                    mrktHow?.map((item) => ({
                      value: item?.market,
                      label: item?.market,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
            </>
          )}

          <Form.Item
            name="cmpChallenge"
            label="What challenges do you experience in the scheme?"
            rules={[
              {
                required: false,
                message:
                  "Please add what challenges do you experience in the scheme?",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>
          <Form.Item
            name="cmpFuturePlans"
            label="What future plans do you have for the scheme?"
            rules={[
              {
                required: false,
                message:
                  "Please add what future plans do you have for the scheme?",
              },
            ]}
          >
            <Input className="input" />
          </Form.Item>

          <Form.Item
            name="cmpAvrHouseIncome"
            label="Average Household Income"
            rules={[
              {
                required: false,
                message: "Please add average household income",
              },
            ]}
          >
            <InputNumber
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              className="input flex"
            />
          </Form.Item>
        </div>

        <div className="flex justify-between mt-[1.25rem] ">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center mb-[58px] gap-x-5">
            <div className="w-[150px]">
              <button
                type="button"
                key="back"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[150px]">
              <button
                disabled={saving}
                key="submit"
                type="submit"
                className="cstm-btn-2"
              >
                {saving ? <Spin /> : "Update"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default ProduceMarket;
